/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 **/

$(document).ready(function () {
    $('.trigger-play').on('click touch', function (e) {
        e.preventDefault();
        let video = $(this).closest('.product-grid__video-wraper').find('video');
        $(this).hide();
        video.addClass('active-video').get(0).play();
    });

    $(document).on('click touch', '.active-video', function (e) {
        e.preventDefault();
        let video = $(this);
        video.closest('.product-grid__video-wraper').find('.trigger-play').show();
        video.removeClass('active-video').get(0).pause();
        video.get(0).currentTime = 0;
        video.get(0).load();
    })


    // Impact slider

    $('.impact__myanmar-slider').slick({
        centerMode: true,
        centerPadding: '16px',
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '0px',
                }
            }
        ]
    });

    //  Usage videos

    $("[data-open-lightbox]").on("click touch", function () {
        var lightbox = $(this).attr("href");
        lity(lightbox);
        var video = $(lightbox).find('video');
        video.get(0).currentTime = 0;
        video.get(0).play();
    });

    $(document).on('lity:close', function (event, instance) {
        $('video').each(function () {
            $(this).get(0).pause();
        });
    });

    // Donation

    $('body').on('click touch', '.donation-add', function (e) {
        e.preventDefault()
        var data = {
            id: $('#id-donation').val(),
            quantity: 1
        };
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: data,
            success: function (res) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true,
                }));
            },
            error: function () {

            },
        });

        // if(donation == "yes") {
        //   var data = {
        //     id: $('[name="id-donation"]').val(),
        //     quantity: 0
        //   };
        //   $.ajax({
        //     type: "POST",
        //     url: "/cart/change.js",
        //     dataType: "json",
        //     data: data,
        //     success: function (res) {
        //       Cookies.set('donation', 'no'); 
        //       setTimeout(function(){
        //       $('[name="add-donation"]').prop('checked', false);
        //         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        //           bubbles: true
        //         }));
        //       },1000 ); 
        //     },
        //     error: function () {

        //     },
        //   });

        // } else {
        //   console.log('non');

        //   var data = {
        //     id: $('[name="id-donation"]').val(),
        //     quantity: 1
        //   };
        //   $.ajax({
        //     type: "POST",
        //     url: "/cart/add.js",
        //     dataType: "json",
        //     data: data,
        //     success: function (res) {
        //       Cookies.set('donation', 'yes'); 
        //       setTimeout(function(){
        //         $('[name="add-donation"]').prop('checked', true);
        //         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        //           bubbles: true
        //         }));
        //       },1000 );        
        //     },
        //     error: function () {

        //     },
        //   });
        // }

    });
});

// document.addEventListener('cart:updated', function(event) {
//   var cart = event.detail.cart; // Get the updated content of the cart
//   const checkGift = (element) => element.variant_id === 49599221170505;
//   const giftInCart = cart.items.some(checkGift)

//   if(cart.items_subtotal_price > 4999 && !giftInCart) {
//     $.ajax({
//       url: '/cart/add.js',
//       type: 'post',
//       dataType: 'json',
//       data: 'quantity=1&id=49599221170505',
//       success: function (result){
//         setTimeout(function(){
//           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//             bubbles: true
//           }));
//         }, 1000);  
//       }
//   });
//   } else if(cart.items_subtotal_price < 5000 && giftInCart) {
//     $.ajax({
//       url: '/cart/update.js',
//       type: 'post',
//       dataType: 'json',
//       data: {
//         updates: {
//           "49599221170505": 0
//         }
//       },
//       success: function (result){
//         setTimeout(function(){
//           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//             bubbles: true
//           }));
//         }, 1000);  
//       }
//   });
//   }

// if(giftInCart) {
//   $.ajax({
//     url: '/cart/update.js',
//     type: 'post',
//     dataType: 'json',
//     data: {
//       updates: {
//         "49599221170505": 0
//       }
//     },
//     success: function (result){
//       setTimeout(function(){
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//           bubbles: true
//         }));
//       }, 1000);  
//     }
// });
// }
// });


// Gift based on products in cart

// 2 gifts

// document.addEventListener('cart:updated', function (event) {
//     var cart = event.detail.cart;
//     const checkGift1 = (element) => element.variant_id === 50734623752521;
//     const checkGift2 = (element) => element.variant_id === 32222094852184;
//     const allowedVariantIds = [51034286915913];

//     const productAllowsGift = cart.items.some(item =>
//         allowedVariantIds.includes(item.variant_id)
//     );
//     const gift1InCart = cart.items.some(checkGift1);
//     const gift2InCart = cart.items.some(checkGift2);
//     const giftPreviouslyRemoved = sessionStorage.getItem('giftRemoved') === 'true';

//     // Check if before Jan 26, 2025 23:59
//     const deadline = new Date('2025-01-26T23:59:00');
//     const isBeforeDeadline = new Date() < deadline;

//     if (!giftPreviouslyRemoved && productAllowsGift) {
//         if (isBeforeDeadline) {
//             // Add both gifts before deadline
//             if (!gift1InCart) {
//                 $.ajax({
//                     url: '/cart/add.js',
//                     type: 'post',
//                     dataType: 'json',
//                     data: 'quantity=1&id=50734623752521',
//                     success: function (result) {
//                         if (!gift2InCart) {
//                             $.ajax({
//                                 url: '/cart/add.js',
//                                 type: 'post',
//                                 dataType: 'json',
//                                 data: 'quantity=1&id=32222094852184',
//                                 success: function (result) {
//                                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                                         bubbles: true
//                                     }));
//                                 }
//                             });
//                         } else {
//                             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                                 bubbles: true
//                             }));
//                         }
//                     }
//                 });
//             } else if (!gift2InCart) {
//                 $.ajax({
//                     url: '/cart/add.js',
//                     type: 'post',
//                     dataType: 'json',
//                     data: 'quantity=1&id=32222094852184',
//                     success: function (result) {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                             bubbles: true
//                         }));
//                     }
//                 });
//             }
//         } else {
//             // Add only gift1 after deadline
//             if (!gift1InCart) {
//                 $.ajax({
//                     url: '/cart/add.js',
//                     type: 'post',
//                     dataType: 'json',
//                     data: 'quantity=1&id=50734623752521',
//                     success: function (result) {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                             bubbles: true
//                         }));
//                     }
//                 });
//             }
//         }
//     }
// });

// function addGiftToCart(variantId) {
//     $.ajax({
//         url: '/cart/add.js',
//         type: 'post',
//         dataType: 'json',
//         data: `quantity=1&id=${variantId}`,
//         success: function (result) {
//             setTimeout(function () {
//                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                     bubbles: true
//                 }));
//             }, 1000);
//         }
//     });
// }

// Single gift with date range and cart amount condition
// document.addEventListener('cart:updated', function (event) {
//     var cart = event.detail.cart;
//     const checkGiftMarch = (element) => element.variant_id === 51247394357577;
//     const giftInCart = cart.items.some(checkGiftMarch);
//     const giftPreviouslyRemoved = sessionStorage.getItem('giftRemovedMarch') === 'true';

//     // Check if between March 6, 2025 00:01 and March 12, 2025 23:59
//     const startDate = new Date('2025-03-05T23:59:00');
//     const endDate = new Date('2025-03-16T23:59:00');
//     const now = new Date();
//     const isWithinDateRange = now >= startDate && now <= endDate;

//     // Calculate subtotal excluding the gift
//     const subtotalExcludingGift = cart.items.reduce((sum, item) => {
//         if (item.variant_id !== 51247394357577) {
//             return sum + item.final_line_price;
//         }
//         return sum;
//     }, 0);

//     // Check if cart total is >= €50 (5000 cents)
//     const meetsCartMinimum = subtotalExcludingGift >= 5000;

//     if (isWithinDateRange && !giftInCart && meetsCartMinimum) {
//         $.ajax({
//             url: '/cart/add.js',
//             type: 'post',
//             dataType: 'json',
//             data: 'quantity=1&id=51247394357577',
//             success: function (result) {
//                 setTimeout(function () {
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                         bubbles: true
//                     }));
//                 }, 1000);
//             },
//             error: function (error) {
//                 console.error('Error adding gift:', error);
//             }
//         });
//     } else if (giftInCart && (!meetsCartMinimum || !isWithinDateRange)) {
//         $.ajax({
//             url: '/cart/update.js',
//             type: 'post',
//             dataType: 'json',
//             data: {
//                 updates: {
//                     "51247394357577": 0
//                 }
//             },
//             success: function (result) {
//                 setTimeout(function () {
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                         bubbles: true
//                     }));
//                 }, 1000);
//             },
//             error: function (error) {
//                 console.error('Error removing gift:', error);
//             }
//         });
//     }
// });

// COMMENTED OUT - Remove gift variants when cart goes below €150 and limit quantities
// document.addEventListener('cart:updated', function (event) {
//     var cart = event.detail.cart;

//     // Gift variant IDs for the donation totebag
//     const giftVariantIds = [50281969221961, 50281969254729];

//     // Check if any gift variant is in cart
//     const giftInCart = cart.items.some(item => giftVariantIds.includes(item.variant_id));

//     // Calculate subtotal excluding the gift variants
//     const subtotalExcludingGift = cart.items.reduce((sum, item) => {
//         if (!giftVariantIds.includes(item.variant_id)) {
//             return sum + item.final_line_price;
//         }
//         return sum;
//     }, 0);

//     // Check if cart total is below €150 (15000 cents)
//     const isBelowMinimum = subtotalExcludingGift < 15000;

//     // Check for quantity limits and prepare updates
//     const updates = {};
//     let needsUpdate = false;

//     // Check for quantities > 1 and limit them
//     cart.items.forEach(item => {
//         if (giftVariantIds.includes(item.variant_id) && item.quantity > 1) {
//             console.log(`Limiting gift variant ${item.variant_id} from ${item.quantity} to 1`);
//             updates[item.variant_id] = 1;
//             needsUpdate = true;
//         }
//     });

//     // Remove gifts if below minimum
//     if (giftInCart && isBelowMinimum) {
//         giftVariantIds.forEach(variantId => {
//             updates[variantId] = 0;
//         });
//         needsUpdate = true;
//     }

//     // Apply updates if needed
//     if (needsUpdate) {
//         $.ajax({
//             url: '/cart/update.js',
//             type: 'post',
//             dataType: 'json',
//             data: {
//                 updates: updates
//             },
//             success: function (result) {
//                 setTimeout(function () {
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                         bubbles: true
//                     }));
//                 }, 1000);
//             },
//             error: function (error) {
//                 console.error('Error updating cart:', error);
//             }
//         });
//     }
// });

// COMMENTED OUT - Direct quantity change listener for gift variants
// document.addEventListener('DOMContentLoaded', function () {
//     // Use event delegation to catch quantity changes on gift variants
//     document.addEventListener('change', function (e) {
//         if (e.target.name && e.target.name.startsWith('updates[') &&
//             (e.target.name.includes('50281969221961') || e.target.name.includes('50281969254729'))) {

//             const newQuantity = parseInt(e.target.value);
//             console.log(`Gift quantity manually changed to: ${newQuantity}`);

//             if (newQuantity > 1) {
//                 console.log(`Preventing quantity > 1, setting to 1`);
//                 e.target.value = 1;

//                 // Trigger form submission to update cart
//                 const form = e.target.closest('form');
//                 if (form) {
//                     form.dispatchEvent(new Event('submit'));
//                 }
//             }
//         }
//     });
// });

// Optional: Add remove button listener for the new gift
// document.addEventListener('DOMContentLoaded', function () {
//     document.addEventListener('click', function (e) {
//         if (e.target.id === 'line-item__remove-button-51247394357577') {
//             sessionStorage.setItem('giftRemovedMarch', 'true');
//         }
//     });
// });

// // ========================================
// // NEW SEPTEMBER 2025 GIFT PROMOTION
// // ========================================

// // Global variable to store stock information for the second phase gift
// let secondPhaseGiftStock = null;
// const STOCK_THRESHOLD = 10; // TODO: Change this value as needed
// const PHASE_2_GIFT_LIMIT = 25; // Maximum number of Phase 2 gifts to give away

// /**
//  * Helper function to check stock for a variant using Shopify's AJAX API
//  * @param {string} variantId - The variant ID to check stock for
//  * @returns {Promise<number>} - Promise that resolves to the available stock quantity
//  */
// function checkVariantStock(variantId) {
//     console.log(`🔍 STOCK CHECK: Starting stock check for variant ${variantId}`);

//     return new Promise((resolve, reject) => {
//         // Use the variant-specific endpoint - only reliable way to get stock data
//         $.ajax({
//             url: `/variants/${variantId}.js`,
//             type: 'GET',
//             dataType: 'json',
//             success: function (variant) {
//                 console.log(`✅ STOCK CHECK: Got variant data from /variants/${variantId}.js`);
//                 console.log(`📊 STOCK CHECK: Variant details:`, {
//                     id: variant.id,
//                     title: variant.title,
//                     inventory_quantity: variant.inventory_quantity,
//                     inventory_management: variant.inventory_management,
//                     inventory_policy: variant.inventory_policy,
//                     available: variant.available
//                 });

//                 // Handle different inventory scenarios
//                 let stock;
//                 if (variant.inventory_management === null || variant.inventory_management === undefined) {
//                     // No inventory tracking - assume unlimited stock
//                     stock = 999999; // Large number to represent unlimited
//                     console.log(`📈 STOCK CHECK: No inventory tracking enabled - assuming unlimited stock`);
//                 } else if (variant.available === false) {
//                     // Product marked as unavailable
//                     stock = 0;
//                     console.log(`🚫 STOCK CHECK: Variant marked as unavailable`);
//                 } else {
//                     // Normal inventory tracking
//                     stock = variant.inventory_quantity || 0;
//                     console.log(`📊 STOCK CHECK: Normal inventory tracking - stock: ${stock}`);
//                 }

//                 console.log(`🎯 STOCK CHECK: Final stock count: ${stock}`);
//                 resolve(stock);
//             },
//             error: function (error) {
//                 console.error(`🚨 STOCK CHECK ERROR: /variants/${variantId}.js failed:`, error);
//                 console.log(`⚠️ STOCK CHECK: Assuming no stock due to API error`);
//                 resolve(0); // Fail safe - assume no stock if we can't check
//             }
//         });
//     });
// }

// /**
//  * Main cart update listener for September 2025 gift promotion
//  * Handles both phases of the promotion based on date ranges
//  */
// document.addEventListener('cart:updated', function (event) {
//     // console.log('September 2025 Gift Promotion: Cart updated');
//     var cart = event.detail.cart;

//     // Define variant IDs for the promotion
//     const MAIN_PRODUCT_VARIANT = '52557774291273';  // Main product that triggers gifts
//     const FIRST_PHASE_GIFT = '52894372626761';      // Gift for Sept 10-11 (24 hours)
//     const SECOND_PHASE_GIFT = '32218087882840';     // Gift from Sept 11 onwards (stock limited)

//     // Get main product quantity and gift quantities from cart
//     const mainProductItems = cart.items.filter(item => item.variant_id.toString() === MAIN_PRODUCT_VARIANT);
//     const firstPhaseGiftItems = cart.items.filter(item => item.variant_id.toString() === FIRST_PHASE_GIFT);
//     const secondPhaseGiftItems = cart.items.filter(item => item.variant_id.toString() === SECOND_PHASE_GIFT);

//     const mainProductQuantity = mainProductItems.reduce((sum, item) => sum + item.quantity, 0);
//     const firstPhaseGiftQuantity = firstPhaseGiftItems.reduce((sum, item) => sum + item.quantity, 0);
//     const secondPhaseGiftQuantity = secondPhaseGiftItems.reduce((sum, item) => sum + item.quantity, 0);

//     const mainProductInCart = mainProductQuantity > 0;
//     const firstPhaseGiftInCart = firstPhaseGiftQuantity > 0;
//     const secondPhaseGiftInCart = secondPhaseGiftQuantity > 0;

//     console.log('Main product quantity:', mainProductQuantity);
//     console.log('First phase gift quantity:', firstPhaseGiftQuantity);
//     console.log('Second phase gift quantity:', secondPhaseGiftQuantity);

//     // Define date ranges (Madrid time = UTC+2 in September)
//     const firstPhaseStart = new Date('2025-09-08T20:00:00+02:00');  // Sept 8, 8 PM Madrid time
//     const firstPhaseEnd = new Date('2025-09-11T20:00:00+02:00');    // Sept 11, 8 PM Madrid time
//     const secondPhaseStart = new Date('2025-09-11T20:00:00+02:00'); // Sept 11, 8 PM Madrid time
//     const secondPhaseEnd = new Date('2025-09-17T20:00:00+02:00');   // Sept 17, 8 PM Madrid time

//     const now = new Date();
//     const isFirstPhase = now >= firstPhaseStart && now < firstPhaseEnd;
//     const isSecondPhase = now >= secondPhaseStart && now < secondPhaseEnd;

//     console.log('Current time:', now.toISOString());
//     console.log('Is first phase (Sept 8-11):', isFirstPhase);
//     console.log('Is second phase (Sept 11-17):', isSecondPhase);



//     // PHASE 1: September 8 8PM - September 11 8PM (3 days)
//     if (isFirstPhase) {
//         // console.log('Processing first phase promotion');

//         // Always clean up second phase gift during first phase
//         if (secondPhaseGiftInCart) {
//             // console.log('Removing second phase gift - still in first phase');
//             updateGiftQuantity(SECOND_PHASE_GIFT, 0, 'second phase gift (cleanup)', cart);
//         }

//         if (mainProductInCart) {
//             // Always set gift quantity to match main product quantity
//             if (firstPhaseGiftQuantity !== mainProductQuantity) {
//                 // console.log(`Updating first phase gift quantity from ${firstPhaseGiftQuantity} to ${mainProductQuantity}`);
//                 updateGiftQuantity(FIRST_PHASE_GIFT, mainProductQuantity, 'first phase gift', cart);
//             } else {
//                 // console.log(`First phase gift quantity already matches main product: ${mainProductQuantity}`);
//             }
//         } else {
//             // Remove first phase gift if main product not in cart
//             // console.log('Removing first phase gift - main product not in cart');
//             updateGiftQuantity(FIRST_PHASE_GIFT, 0, 'first phase gift (cleanup)', cart);
//         }
//     }

//     // PHASE 2: September 11 8PM - September 17 8PM (6 days)
//     else if (isSecondPhase) {
//         console.log('Processing second phase promotion');

//         // Always clean up first phase gift during second phase
//         if (firstPhaseGiftInCart) {
//             console.log('Removing first phase gift - now in second phase');
//             updateGiftQuantity(FIRST_PHASE_GIFT, 0, 'first phase gift (expired)', cart);
//         }

//         if (mainProductInCart) {
//             // Check if we have enough gifts left to give away
//             const currentStock = window.SECOND_PHASE_GIFT_STOCK || 0;
//             const giftsGivenAway = 1034 - currentStock; // Calculate how many we've already given
//             const giftsRemaining = PHASE_2_GIFT_LIMIT - giftsGivenAway;

//             console.log(`🎁 PHASE 2: Gift tracking - Original stock: 1034, Current stock: ${currentStock}, Given away: ${giftsGivenAway}, Limit: ${PHASE_2_GIFT_LIMIT}, Remaining: ${giftsRemaining}`);

//             if (giftsRemaining > 0 && giftsRemaining >= mainProductQuantity) {
//                 // We have enough gifts left - set quantity to match main product
//                 if (secondPhaseGiftQuantity !== mainProductQuantity) {
//                     console.log(`✅ PHASE 2: Updating gift quantity from ${secondPhaseGiftQuantity} to ${mainProductQuantity} (${giftsRemaining} gifts remaining)`);
//                     updateGiftQuantity(SECOND_PHASE_GIFT, mainProductQuantity, 'second phase gift', cart);
//                 } else {
//                     console.log(`✅ PHASE 2: Gift quantity already matches main product: ${mainProductQuantity} (${giftsRemaining} gifts remaining)`);
//                 }
//             } else {
//                 // We've reached the gift limit or don't have enough for this quantity
//                 console.log(`❌ PHASE 2: Gift limit reached! Removing gift. Remaining: ${giftsRemaining}, Needed: ${mainProductQuantity}`);
//                 updateGiftQuantity(SECOND_PHASE_GIFT, 0, 'second phase gift (limit reached)', cart);
//             }
//         } else {
//             // Remove second phase gift if main product not in cart
//             console.log('Removing second phase gift - main product not in cart');
//             updateGiftQuantity(SECOND_PHASE_GIFT, 0, 'second phase gift (cleanup)', cart);
//         }
//     }

//     // OUTSIDE PROMOTION PERIODS: Clean up any gifts
//     else {
//         // console.log('Outside promotion periods - cleaning up all gifts');

//         // Clean up all promotion gifts when outside promotion periods
//         if (firstPhaseGiftInCart) {
//             // console.log('Removing first phase gift - outside promotion period');
//             updateGiftQuantity(FIRST_PHASE_GIFT, 0, 'first phase gift (outside period)', cart);
//         }

//         if (secondPhaseGiftInCart) {
//             // console.log('Removing second phase gift - outside promotion period');
//             updateGiftQuantity(SECOND_PHASE_GIFT, 0, 'second phase gift (outside period)', cart);
//         }
//     }
// });

// /**
//  * Helper function to update gift quantity in cart (add or update existing)
//  * @param {string} variantId - The variant ID to update
//  * @param {number} quantity - The desired quantity
//  * @param {string} giftName - Name for logging purposes
//  */
// function updateGiftQuantity(variantId, quantity, giftName, currentCart) {
//     // console.log(`Updating ${giftName} (${variantId}) to quantity ${quantity}`);

//     // Get current cart to find all instances of this variant
//     if (!currentCart) {
//         // Fetch current cart first
//         $.ajax({
//             url: '/cart.js',
//             type: 'get',
//             dataType: 'json',
//             success: function (cart) {
//                 updateGiftQuantity(variantId, quantity, giftName, cart);
//             },
//             error: function (error) {
//                 console.error(`Error fetching cart for ${giftName}:`, error);
//             }
//         });
//         return;
//     }

//     // Find all line items with this variant ID
//     const giftItems = currentCart.items.filter(item => item.variant_id.toString() === variantId);
//     // console.log(`Found ${giftItems.length} line items for ${giftName}:`, giftItems);

//     if (quantity === 0) {
//         // Remove all instances of this gift
//         if (giftItems.length > 0) {
//             const updates = {};
//             giftItems.forEach(item => {
//                 updates[item.key] = 0;
//             });

//             $.ajax({
//                 url: '/cart/update.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: { updates: updates },
//                 success: function (result) {
//                     // console.log(`Successfully removed all ${giftName} instances:`, result);
//                     setTimeout(function () {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                             bubbles: true
//                         }));
//                     }, 1000);
//                 },
//                 error: function (error) {
//                     console.error(`Error removing ${giftName}:`, error);
//                 }
//             });
//         }
//     } else {
//         // First remove all existing instances, then add the correct quantity
//         if (giftItems.length > 0) {
//             const updates = {};
//             giftItems.forEach(item => {
//                 updates[item.key] = 0;
//             });

//             $.ajax({
//                 url: '/cart/update.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: { updates: updates },
//                 success: function (result) {
//                     // console.log(`Removed all existing ${giftName} instances, now adding ${quantity}`);

//                     // Now add the correct quantity
//                     $.ajax({
//                         url: '/cart/add.js',
//                         type: 'post',
//                         dataType: 'json',
//                         data: `quantity=${quantity}&id=${variantId}`,
//                         success: function (result) {
//                             // console.log(`Successfully added ${quantity}x ${giftName}:`, result);
//                             setTimeout(function () {
//                                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                                     bubbles: true
//                                 }));
//                             }, 1000);
//                         },
//                         error: function (error) {
//                             console.error(`Error adding ${giftName}:`, error);
//                         }
//                     });
//                 },
//                 error: function (error) {
//                     console.error(`Error removing existing ${giftName}:`, error);
//                 }
//             });
//         } else {
//             // No existing gifts, just add the quantity
//             $.ajax({
//                 url: '/cart/add.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: `quantity=${quantity}&id=${variantId}`,
//                 success: function (result) {
//                     // console.log(`Successfully added ${quantity}x ${giftName}:`, result);
//                     setTimeout(function () {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                             bubbles: true
//                         }));
//                     }, 1000);
//                 },
//                 error: function (error) {
//                     console.error(`Error adding ${giftName}:`, error);
//                 }
//             });
//         }
//     }
// }

// /**
//  * Helper function to add a gift to the cart (DEPRECATED - use updateGiftQuantity instead)
//  * @param {string} variantId - The variant ID to add
//  * @param {string} giftName - Name for logging purposes
//  */
// function addGiftToCart(variantId, giftName) {
//     // console.log(`Adding ${giftName} (${variantId}) to cart`);
//     updateGiftQuantity(variantId, 1, giftName);
// }

// /**
//  * Helper function to remove a gift from the cart (DEPRECATED - use updateGiftQuantity instead)
//  * @param {string} variantId - The variant ID to remove
//  * @param {string} giftName - Name for logging purposes
//  */
// function removeGiftFromCart(variantId, giftName) {
//     // console.log(`Removing ${giftName} (${variantId}) from cart`);
//     updateGiftQuantity(variantId, 0, giftName);
// }

// /**
//  * Monitor manual quantity changes on September 2025 promotion gifts
//  * Prevents manual changes - gifts should only be managed by the promotion system
//  */
// document.addEventListener('DOMContentLoaded', function () {
//     document.addEventListener('change', function (e) {
//         // Check if this is a quantity change for our promotion gifts
//         if (e.target.name && e.target.name.startsWith('updates[') &&
//             (e.target.name.includes('52894372626761') || e.target.name.includes('32218087882840'))) {

//             const newQuantity = parseInt(e.target.value);
//             // console.log(`September 2025 gift quantity manually changed to: ${newQuantity}`);

//             // Prevent manual changes - the promotion system manages quantities automatically
//             // console.log('Preventing manual gift quantity changes - managed by promotion system');

//             // Reset to original value and let the cart:updated event handle the correct quantity
//             setTimeout(() => {
//                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                     bubbles: true
//                 }));
//             }, 100);
//         }
//     });
// });

// // Optional: Add remove button listeners for September 2025 gifts
// // Uncomment if you want to track manual gift removals
// /*
// document.addEventListener('DOMContentLoaded', function () {
//     document.addEventListener('click', function (e) {
//         if (e.target.id === 'line-item__remove-button-52894372626761') {
//             console.log('First phase gift manually removed');
//             // You can add sessionStorage tracking here if needed
//         }
//         if (e.target.id === 'line-item__remove-button-32218087882840') {
//             console.log('Second phase gift manually removed');
//             // You can add sessionStorage tracking here if needed
//         }
//     });
// });
// */

// // ========================================
// // END SEPTEMBER 2025 GIFT PROMOTION
// // ========================================


// May-June gift promotion
// document.addEventListener('cart:updated', function (event) {
//     console.log('cart:updated');
//     var cart = event.detail.cart;
//     const checkMainProduct = (element) => element.variant_id === 32217629786200;
//     const checkGift = (element) => element.variant_id === 44490910859582;
//     console.log('Cart items:', cart.items);

//     // Find main product and gift quantities
//     const mainProducts = cart.items.filter(checkMainProduct);
//     const gift = cart.items.find(checkGift);
//     const mainProductQuantity = mainProducts.reduce((sum, item) => sum + item.quantity, 0);
//     const giftQuantity = gift ? gift.quantity : 0;

//     console.log('Main products:', mainProducts);
//     console.log('Gift:', gift);
//     console.log('Total main product quantity:', mainProductQuantity);
//     console.log('Gift quantity:', giftQuantity);

//     // Check if between May 22, 2025 23:00 and June 1, 2025 23:59 Spain time
//     const startDate = new Date('2025-05-22T23:00:00+02:00'); // Spain time (UTC+2)
//     const endDate = new Date('2025-06-01T23:59:00+02:00'); // Spain time (UTC+2)
//     const now = new Date();
//     const isWithinDateRange = now >= startDate && now <= endDate;

//     console.log('Is within date range:', isWithinDateRange);

//     if (isWithinDateRange && mainProductQuantity > 0) {
//         console.log('Should update gift quantity');
//         if (giftQuantity !== mainProductQuantity) {
//             console.log('Updating gift quantity to:', mainProductQuantity);
//             $.ajax({
//                 url: '/cart/update.js',
//                 type: 'post',
//                 dataType: 'json',
//                 data: {
//                     updates: {
//                         "44490910859582": mainProductQuantity
//                     }
//                 },
//                 success: function (result) {
//                     console.log('Update success:', result);
//                     setTimeout(function () {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                             bubbles: true
//                         }));
//                     }, 1000);
//                 },
//                 error: function (error) {
//                     console.error('Error updating gift quantity:', error);
//                 }
//             });
//         } else {
//             console.log('Gift quantity already matches main product quantity');
//         }
//     } else {
//         console.log('Conditions not met for gift update:', {
//             isWithinDateRange,
//             mainProductQuantity
//         });
//     }
// });

// Add remove button listener for the May-June gift
// document.addEventListener('DOMContentLoaded', function () {
//     document.addEventListener('click', function (e) {
//         if (e.target.id === 'line-item__remove-button-44490910859582') {
//             sessionStorage.setItem('giftRemovedMay', 'true');
//         }
//     });
// });


// document.addEventListener('DOMContentLoaded', function () {
//     // Listener for the remove button click
//     document.addEventListener('click', function (e) {
//         if (e.target.id === 'line-item__remove-button-50734623752521') {
//             // Set a flag in localStorage indicating the gift was removed
//             sessionStorage.setItem('giftRemoved', 'true');
//         }
//     });
// });

// document.addEventListener('cart:updated', function (event) {
//     var cart = event.detail.cart; // Get the updated content of the cart
//     const checkGift = (element) => element.variant_id === 50734623752521;
//     const allowedVariantIds = [49218973335881];
//     // Check if the cart contains a product variant that allows adding a gift
//     const productAllowsGift = cart.items.some(item =>
//         allowedVariantIds.includes(item.variant_id)
//     );
//     const giftInCart = cart.items.some(checkGift);
//     const giftPreviouslyRemoved = sessionStorage.getItem('giftRemoved') === 'true';

//     if (!giftInCart && productAllowsGift && !giftPreviouslyRemoved) {
//         $.ajax({
//             url: '/cart/add.js',
//             type: 'post',
//             dataType: 'json',
//             data: 'quantity=1&id=50734623752521',
//             success: function (result) {
//                 setTimeout(function () {
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                         bubbles: true
//                     }));
//                 }, 1000);
//             }
//         });
//     }
// });

/* COMMENTED OUT - Threshold-based gifting: €100 and €200
document.addEventListener('cart:updated', function (event) {
    var cart = event.detail.cart;

    // Gift variant IDs
    const GIFT_100_VARIANT = '53242487046473';  // €100 threshold gift
    const GIFT_200_VARIANT = '53242490683721';  // €200 threshold gift
    const giftVariantIds = [GIFT_100_VARIANT, GIFT_200_VARIANT];

    // Check if gifts are in cart
    const gift100InCart = cart.items.some(item => item.variant_id.toString() === GIFT_100_VARIANT);
    const gift200InCart = cart.items.some(item => item.variant_id.toString() === GIFT_200_VARIANT);

    // Check if gifts were manually removed by user
    const gift100Removed = sessionStorage.getItem('thresholdGift100Removed') === 'true';
    const gift200Removed = sessionStorage.getItem('thresholdGift200Removed') === 'true';

    // Calculate subtotal excluding the gift variants (in cents)
    const subtotalExcludingGifts = cart.items.reduce((sum, item) => {
        if (!giftVariantIds.includes(item.variant_id.toString())) {
            return sum + item.final_line_price;
        }
        return sum;
    }, 0);

    // Convert to euros for threshold checking (Shopify uses cents)
    const subtotalInEuros = subtotalExcludingGifts / 100;

    // €200 threshold logic (highest priority)
    if (subtotalInEuros >= 200) {
        // Remove €100 gift if present (€200 takes priority)
        if (gift100InCart) {
            removeThresholdGift(GIFT_100_VARIANT, '€100 threshold gift (replaced by €200 gift)');
        }
        // Add €200 gift if not in cart and not manually removed
        if (!gift200InCart && !gift200Removed) {
            addThresholdGift(GIFT_200_VARIANT, '€200 threshold gift');
        }
    }
    // €100 threshold logic (only if below €200)
    else if (subtotalInEuros >= 100) {
        // Remove €200 gift if present (below €200 threshold)
        if (gift200InCart) {
            removeThresholdGift(GIFT_200_VARIANT, '€200 threshold gift (below threshold)');
        }
        // Add €100 gift if not in cart and not manually removed
        if (!gift100InCart && !gift100Removed) {
            addThresholdGift(GIFT_100_VARIANT, '€100 threshold gift');
        }
    }
    // Below €100 threshold - remove all gifts
    else {
        // Remove both gifts if present
        if (gift100InCart) {
            removeThresholdGift(GIFT_100_VARIANT, '€100 threshold gift (below threshold)');
        }
        if (gift200InCart) {
            removeThresholdGift(GIFT_200_VARIANT, '€200 threshold gift (below threshold)');
        }
    }
});
*/

/* COMMENTED OUT - Helper function to add threshold gift to cart
function addThresholdGift(variantId, giftName) {
    $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: `quantity=1&id=${variantId}`,
        success: function (result) {
            setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }, 1000);
        },
        error: function (error) {
            // Silently fail if variant is not available - don't show anything
            console.log(`${giftName} not available or error occurred`);
        }
    });
}
*/

/* COMMENTED OUT - Helper function to remove threshold gift from cart
function removeThresholdGift(variantId, giftName) {
    $.ajax({
        url: '/cart/update.js',
        type: 'post',
        dataType: 'json',
        data: {
            updates: {
                [variantId]: 0
            }
        },
        success: function (result) {
            setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }, 1000);
        },
        error: function (error) {
            // Silently fail - don't show anything
            console.log(`Error removing ${giftName}`);
        }
    });
}
*/

/* COMMENTED OUT - Track manual removal of threshold gifts
document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        // Track €100 threshold gift removal
        if (e.target.id === 'line-item__remove-button-53242487046473') {
            sessionStorage.setItem('thresholdGift100Removed', 'true');
        }
        // Track €200 threshold gift removal
        if (e.target.id === 'line-item__remove-button-53242490683721') {
            sessionStorage.setItem('thresholdGift200Removed', 'true');
        }
    });
});
*/

/* COMMENTED OUT - Time-based gifting: Nov 26-27, 2025 promo
document.addEventListener('cart:updated', function (event) {
    var cart = event.detail.cart;

    // Promo gift variant ID
    const PROMO_GIFT_VARIANT = '51247394357577';

    // Check if promo gift is in cart
    const promoGiftInCart = cart.items.some(item => item.variant_id.toString() === PROMO_GIFT_VARIANT);

    // Check if gift was manually removed by user
    const promoGiftRemoved = sessionStorage.getItem('promoGiftRemoved') === 'true';

    // Check if promo is active
    function isPromoActive() {
        const now = new Date();

        // For testing - always active (comment out the return true line for production)
        // return true;

        // Production dates (Madrid timezone)
        const startDate = new Date('2025-11-26T20:00:00+01:00'); // Nov 26, 2025 20:00 Madrid time
        const endDate = new Date('2025-11-27T23:59:59+01:00');   // Nov 27, 2025 23:59 Madrid time

        return now >= startDate && now <= endDate;
    }

    // Add promo gift if promo is active and gift not in cart and not manually removed
    if (isPromoActive() && !promoGiftInCart && !promoGiftRemoved) {
        addPromoGift(PROMO_GIFT_VARIANT, 'Nov 26-27 promo gift');
    }
    // Remove promo gift if promo is not active and gift is in cart
    else if (!isPromoActive() && promoGiftInCart) {
        removePromoGift(PROMO_GIFT_VARIANT, 'Nov 26-27 promo gift (promo ended)');
    }
});
*/

/* COMMENTED OUT - Helper function to add promo gift to cart
function addPromoGift(variantId, giftName) {
    $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: `quantity=1&id=${variantId}`,
        success: function (result) {
            setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }, 1000);
        },
        error: function (error) {
            // Silently fail if variant is not available - don't show anything
            console.log(`${giftName} not available or error occurred`);
        }
    });
}
*/

/* COMMENTED OUT - Helper function to remove promo gift from cart
function removePromoGift(variantId, giftName) {
    $.ajax({
        url: '/cart/update.js',
        type: 'post',
        dataType: 'json',
        data: {
            updates: {
                [variantId]: 0
            }
        },
        success: function (result) {
            setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }, 1000);
        },
        error: function (error) {
            // Silently fail - don't show anything
            console.log(`Error removing ${giftName}`);
        }
    });
}
*/

/* COMMENTED OUT - Track manual removal of promo gift
document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        // Track promo gift removal
        if (e.target.id === 'line-item__remove-button-51247394357577') {
            sessionStorage.setItem('promoGiftRemoved', 'true');
        }
    });
});
*/

// Threshold gifting promo
document.addEventListener('cart:updated', function (event) {
    var cart = event.detail.cart;

    // Threshold gift variant IDs
    const THRESHOLD_50_GIFT_VARIANT = '53445207392585';
    const THRESHOLD_60_GIFT_VARIANT = '53746695536969';

    // Check if gifts are in cart
    const threshold50GiftInCart = cart.items.some(item => item.variant_id.toString() === THRESHOLD_50_GIFT_VARIANT);
    const threshold60GiftInCart = cart.items.some(item => item.variant_id.toString() === THRESHOLD_60_GIFT_VARIANT);

    // Check if gifts were manually removed by user
    const threshold50GiftRemoved = sessionStorage.getItem('threshold50GiftRemoved') === 'true';
    const threshold60GiftRemoved = sessionStorage.getItem('threshold60GiftRemoved') === 'true';

    // Calculate subtotal excluding all gift variants (in cents)
    const subtotalExcludingGifts = cart.items.reduce((sum, item) => {
        const variantId = item.variant_id.toString();
        if (variantId !== THRESHOLD_50_GIFT_VARIANT && variantId !== THRESHOLD_60_GIFT_VARIANT) {
            return sum + item.final_line_price;
        }
        return sum;
    }, 0);

    // Convert to euros for threshold checking (Shopify uses cents)
    const subtotalInEuros = subtotalExcludingGifts / 100;

    // €60 threshold logic
    if (subtotalInEuros >= 60) {
        // Add gift if not in cart and not manually removed
        if (!threshold60GiftInCart && !threshold60GiftRemoved) {
            addThresholdGift(THRESHOLD_60_GIFT_VARIANT, '€60 threshold gift');
        }
    }
    // Below €60 threshold - remove gift
    else {
        if (threshold60GiftInCart) {
            removeThresholdGift(THRESHOLD_60_GIFT_VARIANT, '€60 threshold gift (below threshold)');
        }
    }

    // €50 threshold logic
    if (subtotalInEuros >= 50) {
        // Add gift if not in cart and not manually removed
        if (!threshold50GiftInCart && !threshold50GiftRemoved) {
            addThresholdGift(THRESHOLD_50_GIFT_VARIANT, '€50 threshold gift');
        }
    }
    // Below €50 threshold - remove gift
    else {
        if (threshold50GiftInCart) {
            removeThresholdGift(THRESHOLD_50_GIFT_VARIANT, '€50 threshold gift (below threshold)');
        }
    }
});

/**
 * Helper function to add threshold gift to cart
 * @param {string} variantId - The variant ID to add
 * @param {string} giftName - Name for logging purposes
 */
function addThresholdGift(variantId, giftName) {
    $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: `quantity=1&id=${variantId}`,
        success: function (result) {
            setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }, 1000);
        },
        error: function (error) {
            // Silently fail if variant is not available or out of stock - don't show anything
            console.log(`${giftName} not available or out of stock`);
        }
    });
}

/**
 * Helper function to remove threshold gift from cart
 * @param {string} variantId - The variant ID to remove
 * @param {string} giftName - Name for logging purposes
 */
function removeThresholdGift(variantId, giftName) {
    $.ajax({
        url: '/cart/update.js',
        type: 'post',
        dataType: 'json',
        data: {
            updates: {
                [variantId]: 0
            }
        },
        success: function (result) {
            setTimeout(function () {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }, 1000);
        },
        error: function (error) {
            // Silently fail - don't show anything
            console.log(`Error removing ${giftName}`);
        }
    });
}

// Track manual removal of threshold gifts
document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e) {
        // Track €50 threshold gift removal
        if (e.target.id === 'line-item__remove-button-53445207392585') {
            sessionStorage.setItem('threshold50GiftRemoved', 'true');
        }
        // Track €60 threshold gift removal
        if (e.target.id === 'line-item__remove-button-53746695536969') {
            sessionStorage.setItem('threshold60GiftRemoved', 'true');
        }
    });
});


// Cart terms

$(document).ready(function () {
    // Use event delegation to cater to dynamically added buttons
    $(document).on('change', '#cart-terms', function () {
        if ($(this).is(':checked')) {
            // Remove the disabled attribute when checkbox is selected
            $('button[name="checkout"]').prop('disabled', false);
        } else {
            // Add the disabled attribute back when checkbox is deselected
            $('button[name="checkout"]').prop('disabled', true);
        }
    });

    // Optional: Initialize button state based on checkbox state on page load
    if ($('#cart-terms').is(':checked')) {
        $('button[name="checkout"]').prop('disabled', false);
    } else {
        $('button[name="checkout"]').prop('disabled', true);
    }
});


$(document).ready(function () {
    $('.pvr-videos-slider-3').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.pvr-videos-slider-4').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.pvr-videos-slider-5').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.pvr-videos-slider-6').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.pvr-videos-slider-2').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 2,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                },
            },
        ],
    });

    // Initially play video in the first slide
    // $('.slick-current video').each(function () {
    //     $(this).get(0).play();

    // });

    // New event listener for pause event on all video elements
    // $('.video-content').on('pause', function () {
    //     var video = $(this).get(0);
    //     // video.currentTime = 0; // Reset the video
    //     // video.load(); // Reload the video to show poster
    //     video.controls = false; // Disable video controls

    //     $(this).siblings('.pause-video').hide();
    //     $(this).siblings('.play-video').show();
    //     $(this).siblings('.toggle-audio').hide().text('Sound'); // Also hide and reset sound button
    // });


    // Event listener for play button
    $('.play-video').on('click', function () {
        // Pause and reset all videos
        $('.video-content').each(function () {
            var video = $(this).get(0);
            video.pause();
            // video.currentTime = 0; // Reset the video
            // video.load(); // Ensure poster is shown
            video.controls = false; // Disable video controls
        });

        // Show all play buttons and update sound buttons
        $('.play-video').not(this).show();
        $('.toggle-audio').text('Sound');

        // Play the clicked video
        var video = $(this).siblings('.video-content').get(0);
        video.play();
        video.muted = false; // Unmute the video
        video.controls = true; // Enable video controls

        // Show and update this sound button
        // $(this).siblings('.toggle-audio').show().text('Mute');

        // Show and update this pause button
        $(this).siblings('.pause-video').show();

        // Hide this play button
        $(this).hide();
    });


    // Event listener for audio toggle button
    $('.toggle-audio').on('click', function () {
        var video = $(this).siblings('.video-content').get(0);
        video.muted = !video.muted;
        $(this).text(video.muted ? 'Sound' : 'Mute'); // Change button text based on state
    });

    // Event listener for pause button
    $('.pause-video').on('click', function () {
        var video = $(this).siblings('.video-content').get(0);
        video.pause();
        // video.currentTime = 0; // Reset the video
        // video.load(); // Ensure poster is shown
        video.controls = false; // Disable video controls

        // Hide pause button and show play button
        $(this).hide();
        $(this).siblings('.play-video').show();
        $(this).siblings('.toggle-audio').hide().text('Sound'); // Also hide and reset sound button
    });


    // Initially play video in the first slide
    if (window.innerWidth > 768) {
        $('.slick-current video').each(function () {
            $(this).get(0).play();
        });
    }
});



$(document).ready(function () {
    $('.testimonials-slider').slick({
        centerMode: true,
        arrows: false,
        centerPadding: '60px',
        slidesToShow: 3,
        dots: true,
        responsive: [
            {
                breakpoint: 740,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                },
            },
        ],
    });

});

document.addEventListener("DOMContentLoaded", function () {
    var slides = document.querySelectorAll('.pvr-results-card-before-after-slide');

    slides.forEach(slide => {
        slide.addEventListener('click', function () {
            // Get the parent `.pvr-results-card` of the clicked slide
            var parentCard = this.closest('.pvr-results-card');

            // Find all container and slide elements within the same `.pvr-results-card`
            var containers = parentCard.querySelectorAll('.img-comp-container');
            var siblingSlides = parentCard.querySelectorAll('.pvr-results-card-before-after-slide');

            // Remove active class from all containers within the same card
            containers.forEach(container => container.classList.remove('active'));

            // Reset all slides to inactive within the same card
            siblingSlides.forEach(s => s.classList.remove('active'));

            // Add active class to the clicked slide
            this.classList.add('active');

            // Get the target attribute from the clicked slide
            var targetId = this.getAttribute('target');
            var targetContainer = parentCard.querySelector(targetId);

            if (targetContainer) {
                targetContainer.classList.add('active');
                // Initialize the comparisons for the container only if not already initialized
                initComparisonsForContainer(targetContainer);
            }
        });
    });

    // Initialize comparison for all initially active containers
    var initiallyActiveContainers = document.querySelectorAll('.img-comp-container.active');
    initiallyActiveContainers.forEach(container => {
        initComparisonsForContainer(container);
    });
});

function initComparisonsForContainer(container) {
    /* Find all 'overlay' elements that have not been initialized in the specified container */
    var overlays = container.querySelectorAll(".img-comp-overlay:not([data-initialized])");
    overlays.forEach(overlay => {
        compareImages(overlay);
        overlay.setAttribute('data-initialized', 'true'); // Mark as initialized
    });
}

function compareImages(img) {
    var slider, clicked = 0, w, h;
    w = img.offsetWidth;
    h = img.offsetHeight;
    img.style.width = (w / 2) + "px";
    slider = document.createElement("DIV");
    slider.setAttribute("class", "img-comp-slider");
    img.parentElement.insertBefore(slider, img);
    slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
    slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";

    slider.addEventListener("mousedown", slideReady);
    window.addEventListener("mouseup", slideFinish);
    slider.addEventListener("touchstart", slideReady);
    window.addEventListener("touchend", slideFinish);

    function slideReady(e) {
        e.preventDefault();
        clicked = 1;
        window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
    }

    function slideFinish() {
        clicked = 0;
    }

    function slideMove(e) {
        if (clicked === 0) return;
        var pos = getCursorPos(e);
        pos = Math.max(0, Math.min(pos, w));
        slide(pos);
    }

    function getCursorPos(e) {
        e = (e.changedTouches) ? e.changedTouches[0] : e;
        var a = img.getBoundingClientRect();
        var x = e.pageX - a.left - window.pageXOffset;
        return x;
    }

    function slide(x) {
        img.style.width = x + "px";
        slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
    }
}

// Bolsa verano

document.body.addEventListener('click', function (event) {
    // Check if the clicked element has the class 'donation-swatch'
    if (event.target.classList.contains('donation-swatch')) {
        // Remove 'active' class from all swatches
        document.querySelectorAll('.donation-swatch').forEach(swatch => {
            swatch.classList.remove('active');
        });

        // Add 'active' class to the clicked swatch
        event.target.classList.add('active');

        // Retrieve data attributes from the clicked swatch
        const idDonation = event.target.getAttribute('data-id-donation');
        const src = event.target.getAttribute('data-src');

        // Update the input and image src with the new data
        document.getElementById('id-donation').value = idDonation;
        document.getElementById('donation-image').src = src;
    }
});

